import { observer } from 'mobx-react';
import { useStore } from '../../store/store';

const ProfilerCurrencyFormatSwitch = observer(() => {
  const { utilsStore } = useStore();

  const toggle = () => {
    utilsStore.setProfilerFinancialsFormatUnit(
      utilsStore.profilerFinancialsFormatUnit === 'euroMillions' ? 'euroThousands' : 'euroMillions'
    );
  };

  const values = [
    {
      name: '€M',
      value: 'euroMillions',
      selected: utilsStore.profilerFinancialsFormatUnit === 'euroMillions'
    },
    {
      name: "€'000",
      value: 'euroThousands',
      selected: utilsStore.profilerFinancialsFormatUnit === 'euroThousands'
    }
  ];

  return (
    <div className="pcfs-main-wrap noselect" onClick={toggle}>
      {values.map((el) => {
        return (
          <div key={el.value} className={`pcfs-value ${el.selected ? 'active' : 'notactive'}`}>
            {el.name}
          </div>
        );
      })}
    </div>
  );
});

export default ProfilerCurrencyFormatSwitch;
